import CelebrationWinsMediator from 'Mediator/celebration-wins-mediator';
import Components from 'slotworks/components/components';
import GameState from 'slotworks/model/game-state';
import soundManager from 'slotworks/sound/sound-manager';
import { StateMachine } from 'slotworks/state-machine/state-machine';
import State from 'slotworks/state-machine/states/state';
import { parallel } from 'slotworks/utils/race-utils';
import WildSticky from './wild-sitcky';

export default class SpecialSymbolCelebration extends State {
    private symbol: string;

    constructor(stateMachine: StateMachine, symbol: string) {
        super(stateMachine);

        this.symbol = symbol;
    }

    public onEnter() {
        const record = GameState.getCurrentGame().getCurrentRecord();

        const totalWin = GameState.getCurrentGame().totalCreditsWon;
        const raceFuncs = [];
        const allWinsMediator = new CelebrationWinsMediator();
        raceFuncs.push(() => allWinsMediator.start());

        let onDisplayComplete = () => {
            Components.celebrateWin.hide();
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, 750);
        };
        parallel(raceFuncs).then(() => {
            onDisplayComplete();
            this.complete();
        });
        setTimeout(() => soundManager.customEvent('symbol_' + this.symbol + '_celebrate'), 500);

        WildSticky.setBaseContainerVisibility(false);
    }
}



// WEBPACK FOOTER //
// ./src/states/special-symbol-celebration.ts